<template>
  <div class="companyIntr">
    <ComponentHeader v-bind:index="index" />

    <div id="image" class="image">
      <div>ABOUT US</div>
      <div>关于峰润洗涤</div>
    </div>

    <section>
      <el-row class="block">
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="bt">企业简介</el-col>

        <div class="line"></div>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="bt_sub">“社会责任”</el-col>

        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="title">
          响应国家号召，峰润洗涤将实现“节能减排”、把“碳中和”看做是企业义不容辞的社会责任</el-col>
        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="pic_one">
          <!-- <div> -->
          <img src="../assets/image/pic_01.jpg" alt="" />
          <!-- </div> -->
        </el-col>

        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="title">
          厂区厂房已覆盖太阳能光伏，部分生产使用绿色清洁能源</el-col>

        <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20" class="pic_two">
          <div>
            <img src="../assets/image/pic_two.png" alt="" />
          </div>
        </el-col>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="title">
          厂区水、电、蒸汽安装传感器，实时检测分析能耗消耗情况</el-col>

        <div class="line"></div>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="bt_video_intr">企业介绍视频</el-col>
        <div class="content_img">
          <video class="video1" controls="controls" preload="none" poster="../assets/image/MP4.png">
            <source src="http://www.fengrunxidi.cn/introduce.mp4" type="video/mp4" />
            <!-- <source src="../assets/image/intr.mp4" type="video/mp4" /> -->
          </video>
        </div>

        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="bt_aboutMe">关于我们</el-col>

        <el-row class="content">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="bq">
            <div>
              <span><span class="number">1.56</span>万平方米</span>
              <span>规划用地</span>
            </div>
            <div>
              <span> <span class="number">0.97</span> 万平方米</span>
              <span>建筑面积</span>
            </div>
            <div class="bottom">
              <span><span class="number">1.25</span>万吨/年</span>
              <span>医用纺织品</span>
            </div>
            <div class="bottom">
              <span><span class="number">353</span>台（套）</span>
              <span>洗涤设备</span>
            </div>
          </el-col>
          <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11" class="wenzi">
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;泰州市峰润洗涤服务有限公司成立于2017年5月，主要从事服装、纺织品洗涤服务。现占地面积15666.3平方米，标准厂房9966平方米，拥有两条全自动洗涤生产主线，具有1.25万吨医用纺织品、72.5万件服装洗涤能力，现有员工116人，纺织品洗涤技师（高级）4人，实现洗涤由小作坊式生产向工厂化生产的飞跃。洗涤污水集中处理且循环利用，为环境治理、减少水污染作出了贡献。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;厂房建设及管理等符合《中华人民共和国卫生行业标准》（WS/T508－2016）有关要求。污染区和清洁区完全隔离，配备隔离式水洗机和洗衣笼。污染区设医用织物接收与分拣间、洗涤消毒间、污车存放处和更衣（缓冲）间等；清洁区设烘干间，熨烫、修补、折叠间，储存与发放间、洁车存放处及更衣（缓冲）间等。清洁区内设置质检室，质检分感观检查和仪器设备检测，同时公司又委托第三方进行质量抽检，感染织物设专区洗涤消毒。厂内污水处理设施完善，达标排放，已具有环保部门关于“公用纺织品及服务洗涤环境影响报告表”的批复。公司为应对突发事件备有蓄水池、燃气锅炉、自备发电机组。安全生产也是公司重视的环节，现设两名专职安全员，有5人持有安全员证。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;公司十分重视诚信及企业文化建设，秉承“诚信、优质、团结、敬业”的企业精神，恪守“以完美服务为核心，以洗涤质量求生存，以用户满意为准则”的服务宗旨，不断提高质量管理和生产水平。运行几年来，公司业务不断发展，目前承担了江苏省苏北人民医院租赁洗涤服务、常州市第一人民医院租赁洗涤服务、泰州市第二人民医院租赁洗涤服务、泰州市中医院洗涤服务、泰州市第四人民医院洗涤服务等工作，洗涤服务质量不断提升，得到服务单位多次表扬。
            </p>
          </el-col>
        </el-row>

        <div :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="seeMore">
          <button @click="back()">返回</button>
        </div>
      </el-row>
    </section>

    <ComponentFooter />
  </div>
</template>


<script>
import "../ui/ui.js";
import ComponentHeader from "../components/Header.vue";
import ComponentFooter from "../components/Footer.vue";

export default {
  components: { ComponentFooter, ComponentHeader },
  name: "Home",
  data() {
    return {
      index: "2",
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.companyIntr {
  height: 100%;

  .el-row {
    margin: 0 !important;
  }

  .image {
    width: 100%;
    background: url("../assets/image/1-01-01.png") no-repeat;
    background-size: 100% 100%;
    height: 3.2rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    div {
      color: #d2f9e9;
      font-weight: 400;

      &:first-child {
        font-size: 0.18rem;
      }

      &:last-child {
        font-size: 0.15rem;
      }
    }
  }

  section {
    // margin-bottom: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .block {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      text-align: center;

      .bt {
        margin-top: 0.22rem;
        font-weight: bold;
        color: #1f948d;
        font-size: 0.16rem;
      }

      .bt_video_intr {
        margin-bottom: 13px;
        font-weight: bold;
        color: #1f948d;
        font-size: 0.16rem;
      }

      .bt_sub {
        font-size: 0.09rem;
        margin-bottom: 10px;
      }

      .title {
        font-size: 0.07rem;
      }

      .title2 {
        margin-top: -10px;
      }

      .pic_one {
        margin: 20px 0;
        font-size: 0;

        img {
          width: 40%;
        }
      }

      .pic_two {
        margin-bottom: 20px;
        margin-top: 20px;
        font-size: 0;

        div {
          img {
            width: 40%;
          }
        }
      }

      .content_img {
        width: 90%;
        margin: 0 auto;
        font-size: 0;

        video {
          width: 100%;
        }
      }

      .content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;

        .bq {
          // width: 50%;
          font-size: 0.09rem;
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;

          div {
            width: 40%;
            height: 72px;
            border: 1px solid #1f948d;
            padding: 10px 0 0 20px;

            span {
              text-align: left;

              &:first-child {
                color: #1f948d;
                display: block;
                font-size: 0.1rem;

                .number {
                  font-size: 0.12rem;
                  font-weight: bold;
                  display: inline-block;
                }
              }

              &:last-child {
                font-size: 0.12rem;
                display: block;
              }
            }
          }

          div.bottom {
            margin: 20px 0;
          }
        }

        .wenzi {
          // width: 50%;
          margin: 0 auto;
          font-size: 0.08rem;
          text-align: left;
        }
      }

      .seeMore {
        font-size: 0.7rem;
        display: flex;
        justify-content: center;
        margin: 25px 0 22px 0;

        button {
          width: 84px;
          height: 33px;
          background: #e6fffb;
          border-radius: 30px;
          color: #000;
          outline: 0;
          border: 0;
        }
      }

      .bt_aboutMe {
        margin: 13px 0;
        font-weight: bold;
        color: #1f948d;
        font-size: 0.16rem;
      }

      .line {
        width: 90%;
        height: 1px;
        border-bottom: 1px dashed #707070;
        margin: 13px 0 15px 0;
      }
    }
  }
}
</style>